import { action, makeObservable, observable, reaction } from 'mobx';
import { userInfoStore } from '../../../store/userInfoStore';
import { pixiComponents } from '../fastTradeGameContent/pixiComponent';
import { RoundStatus } from '../../../core/constants/roundStatus';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { freeBetStore } from '../../../store/freeBetStore';

class FastTradeBetStore {
  betBlocks = [];

  time = null;

  roundId = null;

  isBetsClosed = false;

  decisionDuration = null;

  isFreebetEnded = false;

  gameLatestResults = [];

  gameTranslations = {};

  constructor() {
    makeObservable(this, {
      roundId: observable.deep,
      betBlocks: observable.deep,
      isBetsClosed: observable.deep,
      isFreebetEnded: observable.deep,
      decisionDuration: observable.deep,
      gameLatestResults: observable.deep,
      gameTranslations: observable.deep,
      time: observable.deep,
      setBetBlocks: action,
      setIsBetsClosed: action,
      setDecisionDuration: action,
      setGameLatestResults: action,
      setIsFreebetEnded: action,
      setGameTranslations: action.bound,
      updateLatestResults: action,
      setTime: action,
      setRoundId: action,
    });

    reaction(
      () => userInfoStore.betAmount,
      (value) => {
        pixiComponents.PixiComponent.chart.betBlocks.setSelectedAmount(value);
      }
    );
    reaction(
      () => this.roundId,
      (value) => {
        betHistoryStore.setGameCurrentRoundId(value);
      }
    );
    reaction(
      () => [this.roundId, this.isBetsClosed],
      (value, prev) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        if (value && prev && value !== prev) {
          setIsAllowedChangeCurrency(!this.isBetsClosed);
        }
      }
    );
    reaction(
      () => [this.roundId, this.isBetsClosed],
      () => {
        if (
          freeBetStore.currentFreeBet &&
          !freeBetStore.currentFreeBet.remainingCount &&
          !this.isBetsClosed &&
          this.isFreebetEnded
        ) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  setDecisionDuration(second) {
    this.decisionDuration = second;
  }

  setTime(time) {
    this.time = time;
  }

  setRoundId(id) {
    this.roundId = id;
  }

  setIsFreebetEnded(bool) {
    this.isFreebetEnded = bool;
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  setBetBlocks(betBlocks) {
    this.betBlocks = betBlocks;
  }

  setGameTranslations(data) {
    this.gameTranslations = data;
  }

  setGameLatestResults(gameLatestResults) {
    this.gameLatestResults = gameLatestResults
      .filter((item) => item.status === RoundStatus.finished)
      .slice(0, 5)
      .reverse();
  }

  updateLatestResults(lastResult) {
    const newResults = this.gameLatestResults;
    this.gameLatestResults.shift();
    setTimeout(() => {
      this.gameLatestResults = [...newResults, lastResult];
    }, 25);
  }
}

export const fastTradeBetStore = new FastTradeBetStore();
